import React, {Component} from 'react';
import PrintPreview from './PrintPreview';
import HrStore from '../../stores/HrStore'

const DEFAULT_ROW = 40
const localStorageKey = 'kkc.employee'
class PrintReportEmployee extends Component {

  constructor(...args){
    super(...args)
    this.state = {
        loading:false,
        report_title:'กำลังดึงข้อมูล..',
        dataList:[],
        sort: JSON.parse(localStorage.getItem(localStorageKey)) || {sortStatus:'',sortStatus2:'',sortStatus3:'',sortStatus4:''},
        visible_fields:[]
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData(this.props.status,this.props.query)
  }

  getTitle(field) {
    let title = ''
    title = (
      field==='employee_id'?'รหัสพนักงาน':field==='first_name'?'ชื่อ':field==='last_name'?'นามสกุล':field==='nick_name'?'ชื่อเล่น'
      :field==='mobile'?'มือถือ':field==='address_registration'?'ทะเบียนบ้าน':field==='current_address'?'ที่อยู่ปัจจุบัน':field==='gender'?'เพศ'
      :field==='religion'?'ศาสนา':field==='race'?'เชื้อชาติ':field==='nationality'?'สัญชาติ':field==='height'?'ส่วนสูง':field==='weight'?'นำ้หนัก'
      :field==='marriage_status'?'สถานะ':field==='children'?'จำนวนบุตร':field==='dob_day'?'วันเดือนปีเกิด':field==='dob_month'?'วันเดือนปีเกิด':field==='dob_year'?'วันเดือนปีเกิด'
      :field==='id_card'?'บัตรประชาชน':field==='ssn'?'เลขที่ประกันสังคม':field==='no_taxpayer'?'เลขที่ผู้เสียภาษี':field==='bank_name'?'ธนาคาร':field==='bank_account'?'เลขที่บัญชี'
      :field==='start_work_date'?'เริ่มทำงาน':field==='permanance_work_date'?'บรรจุเป็นพนักงาน':field==='position'?'ตำแหน่ง':field==='department'?'แผนก'
      :field==='work_status'?'สถานะการทำงาน':field==='slip_per_month'?'ออกสลิป':field==='exit_date'?'ลาออกวันที่':field==='exit_reason'?'เหตุที่ออก'
      :field==='exit_remark'?'หมายเหตุ':field==='net_saving'?'เงินสะสม(ปัจจุบัน)':field==='slip_by'?'ผู้ออกสลิปเงินเดือน':field
    )
    return title
  }

  loadData(status,query) {
    let {dataList,sort} = this.state
    HrStore.loadEmployeeStatusQuery(query,status,(result)=>{
        let data = result.data
        if (sort.sortStatus===''&&sort.sortStatus2===''&&sort.sortStatus3===''&&sort.sortStatus4==='') {
            data = result.data
        } else {
            if (sort.sortStatus!=='') {
                if (sort.sortStatus===''||sort.sortStatus==='desc') {
                    data.sort()
                    data.reverse()
                } else if (sort.sortStatus==='asc') {
                    data.sort()
                }
            } else if (sort.sortStatus2!=='') {
                if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
                  data.reverse(function(a, b) {
                    if(a['first_name'] < b['first_name']) return -1;
                    if(a['first_name'] > b['first_name']) return 1;
                    return 0;
                  })
                } else if (sort.sortStatus2==='asc') {
                  data.sort(function(a, b) {
                    if(a['first_name'] < b['first_name']) return -1;
                    if(a['first_name'] > b['first_name']) return 1;
                    return 0;
                  })
                }
            } else if (sort.sortStatus3!=='') {
              if (sort.sortStatus3===''||sort.sortStatus3==='desc') {
                data.reverse(function(a, b) {
                  if(a['last_name'] < b['last_name']) return -1;
                  if(a['last_name'] > b['last_name']) return 1;
                  return 0;
                })
              } else if (sort.sortStatus3==='asc') {
                data.sort(function(a, b) {
                  if(a['last_name'] < b['last_name']) return -1;
                  if(a['last_name'] > b['last_name']) return 1;
                  return 0;
                })
              }
            } else if (sort.sortStatus4!=='') {
              if (sort.sortStatus4===''||sort.sortStatus4==='desc') {
                data.reverse(function(a, b) {
                  if(a['nick_name'] < b['nick_name']) return -1;
                  if(a['nick_name'] > b['nick_name']) return 1;
                  return 0;
                })
              } else if (sort.sortStatus4==='asc') {
                data.sort(function(a, b) {
                  if(a['nick_name'] < b['nick_name']) return -1;
                  if(a['nick_name'] > b['nick_name']) return 1;
                  return 0;
                })
              }
            }
        }
        dataList = this.getPagination(data)
        this.setState({report_title:'ไม่พบข้อมูล',dataList:dataList,visible_fields:result.visible_fields})
    })
  }

  renderRowData(emList,indexs) {
    let { visible_fields } = this.state
    if (emList.length===0) {
      return(<tr><td colSpan={visible_fields.length}>ไม่พบข้อมูล</td></tr>)
    } else {
      return emList.map((item, index) => (
        <tr key={index}>
          {visible_fields.map((sitem,sindex)=>
            sitem==='dob_month'||sitem==='dob_year'?''
            :sitem==='dob_day'?<td key={sindex}>{item[sitem]+(item[sitem]!==''&&item.dob_month!==''&&item.dob_year!==''?'/':'')+item.dob_month+(item[sitem]!==''&&item.dob_month!==''&&item.dob_year!==''?'/':'')+item.dob_year}</td>
            :<td key={sindex}>{item[sitem]}</td>
          )}
        </tr>
      ))
    }
  }

  renderTable(items,indexs) {
    let {visible_fields} = this.state
    return(
        <div>
          <table className='table table-print-report-employee'>
            <tbody>
              <tr>
                {visible_fields.map((item,index)=>
                item==='dob_month'||item==='dob_year'?''
                :<td key={index}>{this.getTitle(item)}</td>
                )}
              </tr>  
              {this.renderRowData(items,indexs)}
            </tbody>
          </table>
        </div>
    )
  }

  renderComponentPage(item,index) {
    return(  
        <div className='font-print' key={index}>
            <header className="text-center">
                <h2>{this.props.title}</h2>
            </header>
            <div>
                {this.renderTable(item,index)}
            </div>
        </div>
    )    
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  getPagination(data) {
    let newData = []
    let allData = []
    let checkRow = 0
    data.forEach(function(item,index) {
        if (checkRow<DEFAULT_ROW)
          checkRow++
          newData.push(item)

        if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
          allData.push(newData)
          checkRow = 0
          newData = []
        }
    })  
    
    return allData
  }

  render() {
    let {loading,dataList} = this.state
    if (dataList.length===0) {
        return(
            <PrintPreview 
                loading={loading}
                leftBarTitle={this.props.title}
            >
                {this.renderNoData()}    
            </PrintPreview>
        )
    } else {
        return(
            <PrintPreview 
                loading={loading}
                leftBarTitle={this.props.title}
            >
                {
                    dataList.map((item,index)=>{
                        return(
                            this.renderComponentPage(item,index)
                        )
                    })   
                }
            </PrintPreview>
        )
    }      
  }
}  

PrintReportEmployee.defaultProps = {
  title: 'ตารางพนักงาน'
}
export default PrintReportEmployee;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportEmployee.js